import React, { useState } from 'react';
import '../audience_faqs/audience_faqs.scss'; // Add your custom CSS here
import { captureGAEvent } from '../../sellers_module/shared/helper';

export default function AudienceFaqs() {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        captureGAEvent("click", "Audience_Check_FAQ")
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqs = [
        {
            question: 'What is Shiprocket Audience Pro?',
            answer: 'Shiprocket Audience Pro is a data-driven marketing solution that provides eCommerce sellers with AI-tailored audience segments to optimize their advertising campaigns on platforms like Facebook and Instagram.\nIt aims to enhance targeting precision, reduce ad spend, and maximize return on ad spend (ROAS).\nThe product is currently in Beta.',
        },
        {
            question: 'What is the benefit of using AudiencePro from Shiprocket instead of normal targeting?',
            answer: 'Shiprocket AudiencePro provides AI-created audience segments that ensure better interest matching by reaching customers most likely to buy.\nIt also allows you to focus on customers who have already purchased successfully, increasing chances of repeat sales and improving return on ad spend (ROAS).',
        },
        {
            question: 'What audiences can I choose from?',
            answer: 'You can select from a range of audience segments, including:\n- Active and Frequent Buyers\n- High Spending Buyers\n- Beauty & Wellness Buyers\n- Fashion Enthusiasts\n- Prepaid Buyers\n- Low Risk COD Customers\n- High Risk RTO Buyers (exclusion audience)\n\nThese segments are divided into Starter and Growth plans based on the audience size.\nThe Starter Plan is suitable for smaller campaigns, with up to 4 lakh entries priced at just ₹1,499.\nFor larger campaigns, the Growth Plan provides between 8 to 22 lakh entries, depending on the audience segment, starting at just ₹2,399.',
        },
        {
            question: 'How do I integrate these audiences with my Facebook Ad Manager?',
            answer: 'You can integrate the audiences by logging into your Facebook Ad Manager account using our platform.\nOnce connected, your Facebook Ad account will be linked to our platform and you can share the desired audiences directly.\nYou can then create targeted ad campaigns using these segments.',
        },
        {
            question: 'How can I check if the audiences have been shared successfully?',
            answer: 'Once the audience is shared, it will appear as ‘Added’ in your AudiencePro account.\nYou can also verify the added audiences by checking the All Audiences section in your Facebook Ads Manager account.',
        },
        {
            question: 'Can I start with a free plan?',
            answer: 'Yes, you get access to the High Spending Buyers audience under the Starter plan for free as soon as you connect your Facebook Ad Manager account.',
        },
        {
            question: 'Are there any discounts on the Beta Product?',
            answer: 'Yes, the Beta product is currently available at discounted prices!\nThe audience segments under the Starter Plan are priced at just ₹1499, while the Growth Plan starts from just ₹2399.',
        },
        {
            question: 'Is there a limit to the number of audiences I can activate?',
            answer: 'No, there is no limit to the number of audiences you can activate.\nStarter audiences include up to 4 lakh entries while Growth audiences range from 7 lakh to 22 lakh entries.\n\nYou also get these additional discounts on buying 2 or more audiences:\n- Buy 2 at 10% off\n- Buy 3 at 15% off\n- Buy 4 at 20% off\n\nYou can apply the coupon codes for these discounts during checkout.',
        },
        {
            question: 'How do I pay to activate audiences?',
            answer: 'You can pay for your selected audiences using your Shiprocket wallet.\nMake sure you have a sufficient balance in your wallet to make the payment.',
        },
        {
            question: 'What data sources are used for audience segmentation?',
            answer: 'Shiprocket Audience Pro utilizes a combination of eCommerce data, user behavior analytics, and demographic information to create precise audience segments.',
        },
        {
            question: 'How often are the audience segments updated?',
            answer: 'The audience segments are regularly updated to ensure they reflect the latest user information, making targeting relevant and effective.',
        },
        {
            question: 'Is there any personal data of any customers or buyers shared with anyone?',
            answer: 'No, we follow ethical data practices and do not share customer’s PII information with any user.\nWe only provide audience segments, which you can directly use for your ad campaigns on Facebook.',
        },
        {
            question: 'My audience is not showing in my Facebook account, how to report the issue?',
            answer: 'To raise an issue with sharing audiences, follow these steps:\n1. Click on ‘Raise an Issue’ option at the top.\n2. Select your issue from the drop-down.\n3. Add additional remarks in the textbox and submit the issue.\n\nOur team will get back to you to resolve the issue.',
        },
        {
            question: 'My audience is not in ready status, what to do?',
            answer: 'If your shared audience is not in the ready status, please login to your meta account and accept the shared audience responsibilities to resolve the issue.',
        },
        {
            question: 'Can I exclude certain audiences from my campaigns?',
            answer: 'Yes, you can use the exclusion audiences of High Risk RTO Buyers to improve the effectiveness of your existing campaigns.',
        },
        {
            question: 'Can I get custom audiences made for my business needs?',
            answer: 'Yes, custom audiences are available on request.\nYou can reach out to us at help.audience@shiprocket.com with your specific requirements.',
        },
        {
            question: 'How can I opt out of AudiencePro?',
            answer: 'The audiences are valid for 2 months during the Beta stage.\nThe shared audiences will automatically expire after 2 months or if you remove your Facebook account.',
        },
    ];
        

    return (
        <div className="faq-container">
            <h2 className="faq-header">General <span className="faq" style={{
             fontFamily: "sfprobold",
             color: "white",
             fontSize: "28px",
             background: 'linear-gradient(to right, #C3A3FF 0%, #CACCD0 50%, #9577FF 100%)',
             WebkitTextFillColor: 'transparent',
             WebkitBackgroundClip: 'text',
            }}>{"FAQ's"}</span></h2>
            {faqs.map((faq, index) => (
                <div
                    key={index}
                    className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                    onClick={() => toggleFAQ(index)}
                >
                    <div className="faq-question">
                        <span>{faq.question}</span>
                        <span className="faq-icon">
                            {activeIndex === index ? '▲' : '▼'}
                        </span>
                    </div>
                    {activeIndex === index && (
                       <div 
                       className="faq-answer" 
                       dangerouslySetInnerHTML={{ __html: faq.answer.replace(/\n/g, '<br />') }} 
                   ></div>
                   
                    )}
                </div>
            ))}
        </div>
    );
}
